/**
 * Vérifie si l'utilisateur a atteint la limite maximale de biens de son plan.
 * Source de vérité = activePlan / currentPlan :
 *  - otherDetails.createPropProfileSaleRentDirectory = { key: "custom"|"unlimited", value: <max biens> }
 *  - propertyCount = nombre de biens actuels (injecté par user/activeplan).
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const propertyLimitReached = (activePlan: any): boolean => {
  const plan = activePlan?.activePlan?.[0] || activePlan?.[0];
  const dir = plan?.otherDetails?.createPropProfileSaleRentDirectory;
  if (!dir || dir.key !== "custom") return false;
  return Number(dir.value) <= Number(plan?.propertyCount);
};

export const propertyLimit = (activePlan: any): number => {
  const plan = activePlan?.activePlan?.[0] || activePlan?.[0];
  const dir = plan?.otherDetails?.createPropProfileSaleRentDirectory;
  if (!dir || dir.key !== "custom") return 0;
  return Number(dir.value) || 0;
};